import { motion } from "framer-motion";
import { Flame, Users, Award, Clock, Instagram } from "lucide-react";
import { STATS, ABOUT_IMAGE, INSTAGRAM_REEL_EMBED, INSTAGRAM_REEL_URL } from "@/data/content";

const ICONS = { Flame, Users, Award, Clock };

const About = () => {
  return (
    <section id="sobre" data-testid="about-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <img
            src={ABOUT_IMAGE}
            alt="Entregador Bahia Gás com botijão de gás"
            className="rounded-3xl w-full h-[520px] object-cover shadow-2xl"
          />
          <div
            data-testid="about-since-card"
            className="absolute -bottom-6 right-6 bg-white rounded-2xl shadow-xl px-6 py-5 flex items-center gap-4"
          >
            <span className="flex items-center justify-center w-14 h-14 rounded-xl bg-[#eef1ff]">
              <Flame className="w-7 h-7 text-[#1d3fd9]" />
            </span>
            <div>
              <p className="text-3xl font-extrabold text-[#0f1733] leading-none">1993</p>
              <p className="text-slate-500 text-sm mt-1">Desde então</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-[#1d3fd9] font-bold tracking-widest text-sm mb-4">SOBRE NÓS</p>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0f1733] leading-tight tracking-tight">
            Uma empresa de <span className="text-[#1d3fd9]">Gás de Cozinha</span> e{" "}
            <span className="text-[#1d3fd9]">Água Mineral</span>
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed mt-7">
            O Bahia Gás Ipatinga iniciou suas atividades em 1993, com mais de 33 anos de experiência, sempre com o
            compromisso de garantir que as atividades de instalação e abastecimento de gás estejam em conformidade com
            os mais altos padrões de qualidade.
          </p>
          <p className="text-slate-600 text-lg leading-relaxed mt-5">
            Nosso objetivo é a melhoria contínua da satisfação dos clientes, pautados pela ética, pelo respeito às leis,
            ao meio ambiente e às pessoas.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            {STATS.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <div key={s.label} className="bg-slate-50 rounded-2xl p-5 text-center">
                  <Icon className="w-6 h-6 text-[#1d3fd9] mx-auto mb-3" />
                  <p className="text-2xl font-extrabold text-[#0f1733]">{s.value}</p>
                  <p className="text-slate-500 text-xs mt-1 leading-tight">{s.label}</p>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="max-w-7xl mx-auto px-5 lg:px-8 mt-20 text-center"
        data-testid="about-reel"
      >
        <p className="text-[#1d3fd9] font-bold tracking-widest text-sm mb-3 flex items-center justify-center gap-2">
          <Instagram className="w-5 h-5" /> NO INSTAGRAM
        </p>
        <h3 className="text-2xl lg:text-3xl font-extrabold text-[#0f1733] tracking-tight mb-8">
          Acompanhe nosso dia a dia
        </h3>
        <div className="mx-auto w-full max-w-[400px] rounded-3xl overflow-hidden shadow-2xl bg-white border border-slate-100">
          <iframe
            data-testid="about-reel-iframe"
            src={INSTAGRAM_REEL_EMBED}
            title="Reel Instagram Bahia Gás"
            className="w-full"
            style={{ height: "560px" }}
            frameBorder="0"
            scrolling="no"
            allowtransparency="true"
            allowFullScreen
          />
        </div>
        <a
          href={INSTAGRAM_REEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="about-reel-link"
          className="inline-flex items-center gap-2 mt-6 text-[#1d3fd9] font-semibold hover:underline"
        >
          <Instagram className="w-5 h-5" /> Ver no Instagram
        </a>
      </motion.div>
    </section>
  );
};

export default About;
